import React from "react";
import type { CostPanelProps } from "./CostPanel.types";
import AddCost from "./AddCost/AddCost.component";
import FormulaEditorContainer from "./FormulaEditor/FormulaEditorContainer.component";
import EditDimensionValues from "./EditDimensionValues/EditDimensionValues.component";

const CostPanel: React.FC<CostPanelProps> = (props) => {
  if (
    props.mode === "editDimensionValues" &&
    props.dimensionEditState !== null
  ) {
    return (
      <EditDimensionValues
        key={props.dimensionEditState.dimensionTypeName}
        active={props.active}
        onClose={props.onClose}
        subCategoryName={props.activeSubcategoryName}
        dimensionEditState={props.dimensionEditState}
        dimensionValues={props.dimensionValues}
        onCancel={props.onCancelEditDimensionValues}
        onSubmit={props.onSubmitDimensionValues}
        isSubmitting={props.isSubmittingDimensionValues}
      />
    );
  }

  if (props.mode === "formula") {
    // A dimensioned formula is edited per dimension value, so the value is part of
    // the header's identity; dimensionless subcategories have none to append.
    const titleParts = [
      "Cost Calculation Formula",
      props.activeSubcategoryName,
      props.activeDimensionValue,
    ].filter(Boolean);
    const title = titleParts.join(" · ");
    return (
      <FormulaEditorContainer
        key={`${props.activeSubcategoryId}:${props.activeDimensionValue ?? ""}`}
        active={props.active}
        panelTitle={title}
        subCategoryId={props.activeSubcategoryId}
        dimensionValue={props.activeDimensionValue}
        savedExpression={props.formulaExpression}
        sourceTemplateId={props.sourceTemplateId}
        referencedVariableNames={props.referencedVariableNames}
        onClose={props.onClose}
        onToggleFormulaMode={props.onToggleFormulaMode}
        onConflict={props.onConflict}
      />
    );
  }

  return <AddCost {...props} />;
};

export default CostPanel;
